// extracted by mini-css-extract-plugin
export default {"container":"Lp-z","brandName":"Mp-z","productName":"Np-z","productNamePdpEnhancements":"Op-z","breakLongProductName":"Pp-z"};